import {wrapItem, blockTypeItem, Dropdown, DropdownSubmenu, joinUpItem, liftItem,
             selectParentNodeItem, undoItem, redoItem, icons, MenuItem} from "prosemirror-menu"
import {NodeSelection} from "prosemirror-state"
import {toggleMark} from "prosemirror-commands"
import {wrapInList} from "prosemirror-schema-list"
import {TextField, openPrompt} from "./prompt"

import m from 'mithril';

// Helpers to create specific types of items

let editorstate = {
    entity: '',
    id_entity: 0
}

let customIcons = {
    image: {
        width: 512,
        height: 430,
        path: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0",
    },

    video: {
        width: 55.125,
        height: 55.125,
        path: "M4.167,47.007h46.792c2.302,0,4.167-1.866,4.167-4.167V12.285c0-2.301-1.865-4.167-4.167-4.167H4.167 C1.866,8.118,0,9.984,0,12.285V42.84C0,45.141,1.866,47.007,4.167,47.007z M30.771,44.082h-6.418v-3.965h6.418V44.082z M46.065,11.138h6.418v3.965h-6.418V11.138z M45.875,40.117h6.419v3.965h-6.419V40.117z M35.303,11.138h6.419v3.965h-6.419V11.138 z M35.114,40.117h6.419v3.965h-6.419V40.117z M24.543,11.138h6.418v3.965h-6.418V11.138z M22.743,20.717l9.639,4.82 c2.237,1.119,2.237,2.933,0,4.051l-9.639,4.821c-2.237,1.118-4.052-0.003-4.052-2.506v-8.681 C18.69,20.72,20.505,19.599,22.743,20.717z M13.782,11.138h6.419v3.965h-6.419V11.138z M13.593,40.117h6.418v3.965h-6.418V40.117z M3.021,11.138h6.419v3.965H3.021V11.138z M2.832,40.117h6.419v3.965H2.832V40.117z",
    }
}


function canInsert(state, nodeType) {
    let $from = state.selection.$from
    for (let d = $from.depth; d >= 0; d--) {
        let index = $from.index(d)
        if ($from.node(d).canReplaceWith(index, index, nodeType)) return true
    }
    return false
}



function upload_image(file, id_image, upload_url){
    let progress = 0;
    
    UploadPageState.upload_state = UPLOADER_STATE.UPLOADING;
    // $('.video-selected-message').addClass('hidden')
    // $('.ijf-form').addClass('hidden');
    // var file = UploadPageState.file;
    var xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("PUT", upload_url, true);

    xmlHttpRequest.setRequestHeader("Content-Type", file.type);

    console.log("uploading image");

    xmlHttpRequest.upload.addEventListener("progress", function(e) {
        progress = (e.loaded / e.total) * 100;
        progress = Math.floor(progress);

        console.log(progress);

        if(progress >= 100){
            progress = 100;

            setTimeout(function(){
                // document.location.href = _CONF.base_url + 'api/media/upload_image_finished/' + id_image
                m.request({
                    method: "GET",
                    url: '/api/media/upload_image_finished/' + id_image,
                }).then(function(data) {
                    console.log('UPLOADED!');
                });
            }, 200)
            UploadPageState.upload_state = UPLOADER_STATE.FINISHED;

        }
        m.redraw()
    });
    xmlHttpRequest.upload.addEventListener("loadx", function(e){
        // alert('You successfully uploaded your illustration. You will be now redirected to illustration.');
        setTimeout(function(){
            // document.location.href = _CONF.base_url + 'api/media/upload_image_finished/' + id_image
            m.request({
                method: "GET",
                url: '/api/media/upload_image_finished/' + id_image,
            }).then(function(data) {
                console.log('UPLOADED!');
            });
        }, 200)
        UploadPageState.upload_state = UPLOADER_STATE.FINISHED;
        m.redraw();
    })
    xmlHttpRequest.upload.addEventListener("errorx", function(e){
        alert('Looks like there was problem uploading. Please try again or contact us');
        UploadPageState.upload_state = UPLOADER_STATE.ERROR;
        m.redraw();
    })
    xmlHttpRequest.upload.addEventListener("abortx", function(e){
        alert('Looks like there was problem uploading. Please try again or contact us');
        UploadPageState.upload_state = UPLOADER_STATE.ERROR;
        m.redraw();
    })

    xmlHttpRequest.send(file);
}


function upload_video(file, id_video, upload_url){
    let progress = 0;
    
    UploadPageState.upload_state = UPLOADER_STATE.UPLOADING;

    var xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("PUT", upload_url, true);

    xmlHttpRequest.setRequestHeader("Content-Type", file.type);

    xmlHttpRequest.upload.addEventListener("progress", function(e) {
        progress = (e.loaded / e.total) * 100;
        progress = Math.floor(progress);

        // console.log(progress);

        let element = document.querySelector('ct-video[id_video="' + id_video + '"] .video-loader__percent-container');

        if (element) {
            element.innerHTML = progress + '%';
        }

        if(progress >= 100){
            progress = 100;

            setTimeout(function(){
                m.request({
                    method: "GET",
                    url: '/api/media/upload_video_finished/' + id_video,
                }).then(function(data) {
                    console.log('UPLOADED!');
                });
            }, 200)
            UploadPageState.upload_state = UPLOADER_STATE.FINISHED;

        }
        m.redraw()
    });
    xmlHttpRequest.upload.addEventListener("loadx", function(e){
        setTimeout(function(){
            m.request({
                method: "GET",
                url: '/api/media/upload_video_finished/' + id_video,
            }).then(function(data) {
                console.log('UPLOADED!');
            });
        }, 200)
        UploadPageState.upload_state = UPLOADER_STATE.FINISHED;
        m.redraw();
    })
    xmlHttpRequest.upload.addEventListener("errorx", function(e){
        alert('Looks like there was problem uploading. Please try again or contact us');
        UploadPageState.upload_state = UPLOADER_STATE.ERROR;
        m.redraw();
    })
    xmlHttpRequest.upload.addEventListener("abortx", function(e){
        alert('Looks like there was problem uploading. Please try again or contact us');
        UploadPageState.upload_state = UPLOADER_STATE.ERROR;
        m.redraw();
    })

    xmlHttpRequest.send(file);
}


function insertImageItem(nodeType) {
    return new MenuItem({
        title: "Insert image",
        label: "",
        icon: customIcons.image,
        enable(state) { return canInsert(state, nodeType) },
        run(state, _, view) {
            let {from, to} = state.selection, attrs = null
            if (state.selection instanceof NodeSelection && state.selection.node.type == nodeType)
                attrs = state.selection.node.attrs
            

            var input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/x-png,image/gif,image/jpeg';

            input.onchange = e => { 
                var file = e.target.files[0];

                let selection = null;
                let resolvedPos = null;

                let extension = file.name.split('.').pop().toLowerCase();

                if (extension != 'png' && extension != 'jpg' && extension != 'jpeg' && extension != 'gif') {
                    alert("Wrong file format. Supported: .png, .jpg and .gif");
                    return;
                }

                let data = {
                    type: 'image',
                    entity: editorstate.entity,
                    id_entity: editorstate.id_entity,
                    file: {
                        name: file.name,
                        size: file.size,
                        type: file.type
                    },
                };

               console.log("sending request to /api/media");

                m.request({
                    method: "POST",
                    url: "/api/media",
                    body: data
                }).then(function(data) {
                    setTimeout(e => {
                        if (data.status == 200) {  
                            // node.attrs.src = data.url;
                            let attrs = {
                                // src: data.url, 
                                id_image: data.id_uploaded
                            };

                              console.log("get 200 response");

                            view.dispatch(view.state.tr.setSelection(new NodeSelection(resolvedPos)));
                            view.dispatch(view.state.tr.replaceSelectionWith(nodeType.createAndFill(attrs)));

                            upload_image(file, data.id_uploaded, data.upload_url);

                        } else {
                            // TODO: handle better!
                            alert("ERROR!");
                        }
                    }, 400);
                    // alert("Exercise saved!");
                });

                selection = view.state.selection;

                view.dispatch(view.state.tr.replaceSelectionWith(nodeType.createAndFill()));
                
                resolvedPos = view.state.tr.doc.resolve(
                    view.state.tr.selection.anchor - view.state.tr.selection.$anchor.nodeBefore.nodeSize
                );
                
                view.focus()
            }

            input.click();
        }
    })
}

function insertVideoItem(nodeType) {
    return new MenuItem({
        title: "Insert video",
        label: "",
        icon: customIcons.video,
        enable(state) { return canInsert(state, nodeType) },
        run(state, _, view) {
            let {from, to} = state.selection, attrs = null
            if (state.selection instanceof NodeSelection && state.selection.node.type == nodeType)
                attrs = state.selection.node.attrs
            

            var input = document.createElement('input');
            input.type = 'file';
            // input.accept = 'video/mp4,video/flv,video/mkv,video/mov,video/mpg,video/mpeg,video/avi,video/webm';
            input.accept = '.mp4,.flv,.mkv,.mov,.mpg,.mpeg,.avi,.webm';

            input.onchange = e => { 
                var file = e.target.files[0];

                let extension = file.name.split('.').pop().toLowerCase();

                if (extension != 'mp4' && extension != 'flv' && extension != 'mkv' && extension != 'mov' && extension != 'mpg' && extension != 'mpeg' && extension != 'avi' && extension != 'webm') {
                    alert("Wrong file format. Supported types: mp4, flv, mkv, mov, mpg, avi, webm");
                    return;
                }

                let selection = null;
                let resolvedPos = null;

                let data = {
                    type: 'video',
                    entity: editorstate.entity,
                    id_entity: editorstate.id_entity,
                    file: {
                        name: file.name,
                        size: file.size,
                        type: file.type
                    },
                };

                m.request({
                    method: "POST",
                    url: "/api/media",
                    body: data
                }).then(function(data) {
                    setTimeout(e => {
                        if (data.status == 200) {  
                            // node.attrs.src = data.url;
                            let attrs = {
                                id_video: data.id_uploaded
                            };

                            view.dispatch(view.state.tr.setSelection(new NodeSelection(resolvedPos)));
                            view.dispatch(view.state.tr.replaceSelectionWith(nodeType.createAndFill(attrs)));

                            upload_video(file, data.id_uploaded, data.upload_url);

                        } else {
                            // TODO: handle better!
                            alert("ERROR!");
                        }
                    }, 400);
                    // alert("Exercise saved!");
                });

                selection = view.state.selection;

                view.dispatch(view.state.tr.replaceSelectionWith(nodeType.createAndFill()));
                
                resolvedPos = view.state.tr.doc.resolve(
                    view.state.tr.selection.anchor - view.state.tr.selection.$anchor.nodeBefore.nodeSize
                );
                
                view.focus()
            }

            input.click();
        }
    })
}

function cmdItem(cmd, options) {
    let passedOptions = {
        label: options.title,
        run: cmd
    }
    for (let prop in options) passedOptions[prop] = options[prop]
    if ((!options.enable || options.enable === true) && !options.select)
        passedOptions[options.enable ? "enable" : "select"] = state => cmd(state)

    return new MenuItem(passedOptions)
}

function markActive(state, type) {
    let {from, $from, to, empty} = state.selection
    if (empty) return type.isInSet(state.storedMarks || $from.marks())
    else return state.doc.rangeHasMark(from, to, type)
}

function markItem(markType, options) {
    let passedOptions = {
        active(state) { return markActive(state, markType) },
        enable: true
    }
    for (let prop in options) passedOptions[prop] = options[prop]
    return cmdItem(toggleMark(markType), passedOptions)
}

function linkItem(markType) {
    return new MenuItem({
        title: "Add or remove link",
        icon: icons.link,
        active(state) { return markActive(state, markType) },
        enable(state) { return !state.selection.empty },
        run(state, dispatch, view) {
            if (markActive(state, markType)) {
                toggleMark(markType)(state, dispatch)
                return true
            }
            openPrompt({
                title: "Create a link",
                fields: {
                    href: new TextField({
                        label: "Link target",
                        required: true
                    }),
                    title: new TextField({label: "Title"})
                },
                callback(attrs) {
                    toggleMark(markType, attrs)(view.state, view.dispatch)
                    view.focus()
                }
            })
        }
    })
}

function wrapListItem(nodeType, options) {
    return cmdItem(wrapInList(nodeType, options.attrs), options)
}



// :: (Schema) → Object
// Given a schema, look for default mark and node types in it and
// return an object with relevant menu items relating to those marks:
//
// **`toggleStrong`**`: MenuItem`
//   : A menu item to toggle the [strong mark](#schema-basic.StrongMark).
//
// **`toggleEm`**`: MenuItem`
//   : A menu item to toggle the [emphasis mark](#schema-basic.EmMark).
//
// **`toggleCode`**`: MenuItem`
//   : A menu item to toggle the [code font mark](#schema-basic.CodeMark).
//
// **`toggleLink`**`: MenuItem`
//   : A menu item to toggle the [link mark](#schema-basic.LinkMark).
//
// **`insertImage`**`: MenuItem`
//   : A menu item to insert an [image](#schema-basic.Image).
//
// **`wrapBulletList`**`: MenuItem`
//   : A menu item to wrap the selection in a [bullet list](#schema-list.BulletList).
//
// **`wrapOrderedList`**`: MenuItem`
//   : A menu item to wrap the selection in an [ordered list](#schema-list.OrderedList).
//
// **`wrapBlockQuote`**`: MenuItem`
//   : A menu item to wrap the selection in a [block quote](#schema-basic.BlockQuote).
//
// **`makeParagraph`**`: MenuItem`
//   : A menu item to set the current textblock to be a normal
//     [paragraph](#schema-basic.Paragraph).
//
// **`makeCodeBlock`**`: MenuItem`
//   : A menu item to set the current textblock to be a
//     [code block](#schema-basic.CodeBlock).
//
// **`makeHead[N]`**`: MenuItem`
//   : Where _N_ is 1 to 6. Menu items to set the current textblock to
//     be a [heading](#schema-basic.Heading) of level _N_.
//
// **`insertHorizontalRule`**`: MenuItem`
//   : A menu item to insert a horizontal rule.
//
// The return value also contains some prefabricated menu elements and
// menus, that you can use instead of composing your own menu from
// scratch:
//
// **`insertMenu`**`: Dropdown`
//   : A dropdown containing the `insertImage` and
//     `insertHorizontalRule` items.
//
// **`typeMenu`**`: Dropdown`
//   : A dropdown containing the items for making the current
//     textblock a paragraph, code block, or heading.
//
// **`fullMenu`**`: [[MenuElement]]`
//   : An array of arrays of menu elements for use as the full menu
//     for, for example the [menu bar](https://github.com/prosemirror/prosemirror-menu#user-content-menubar).
export function buildMenuItems(schema, es) {
    let r = {}, type

    editorstate = es

    if (type = schema.marks.strong)
        r.toggleStrong = markItem(type, {title: "Toggle strong style", icon: icons.strong})
        // r.toggleStrong = markItem(type, {title: "Toggle strong style", icon: customIcons.image })
    if (type = schema.marks.em)
        r.toggleEm = markItem(type, {title: "Toggle emphasis", icon: icons.em})
    if (type = schema.marks.code)
        r.toggleCode = markItem(type, {title: "Toggle code font", icon: icons.code})
    if (type = schema.marks.link)
        r.toggleLink = linkItem(type)

    if (type = schema.nodes.mediaimage)
        r.insertImage = insertImageItem(type)
    if (type = schema.nodes.mediavideo)
        r.insertVideo = insertVideoItem(type)
    if (type = schema.nodes.bullet_list)
        r.wrapBulletList = wrapListItem(type, {
            title: "Wrap in bullet list",
            icon: icons.bulletList
        })
    if (type = schema.nodes.ordered_list)
        r.wrapOrderedList = wrapListItem(type, {
            title: "Wrap in ordered list",
            icon: icons.orderedList
        })
    if (type = schema.nodes.blockquote)
        r.wrapBlockQuote = wrapItem(type, {
            title: "Wrap in block quote",
            icon: icons.blockquote
        })
    if (type = schema.nodes.paragraph)
        r.makeParagraph = blockTypeItem(type, {
            title: "Change to paragraph",
            label: "Plain"
        })
    if (type = schema.nodes.code_block)
        r.makeCodeBlock = blockTypeItem(type, {
            title: "Change to code block",
            label: "Code"
        })
    // if (type = schema.nodes.heading)
    //     for (let i = 1; i <= 10; i++)
    //         r["makeHead" + i] = blockTypeItem(type, {
    //             title: "Change to heading " + i,
    //             label: "H" + i,
    //             attrs: {level: i}
    //         })
    if (type = schema.nodes.heading){
        r["makeHead1"] = blockTypeItem(type, {
            title: "Huge heading",
            label: "Huge",
            attrs: {level: 1}
        });

        r["makeHead2"] = blockTypeItem(type, {
            title: "Large heading",
            label: "Large",
            attrs: {level: 2}
        });

        r["makeHead3"] = blockTypeItem(type, {
            title: "Medium heading",
            label: "Medium",
            attrs: {level: 3}
        });

        r["makeHead4"] = blockTypeItem(type, {
            title: "Small heading",
            label: "Small",
            attrs: {level: 4}
        });
    }

    if (type = schema.nodes.horizontal_rule) {
        let hr = type
        r.insertHorizontalRule = new MenuItem({
            title: "Insert horizontal rule",
            label: "Horizontal rule",
            enable(state) { return canInsert(state, hr) },
            run(state, dispatch) { dispatch(state.tr.replaceSelectionWith(hr.create())) }
        })
    }

    let cut = arr => arr.filter(x => x)
    r.insertMenu = new Dropdown(cut([r.insertImage, r.insertHorizontalRule]), {label: "Insert"})
    // r.typeMenu = new Dropdown(cut([r.makeParagraph, r.makeCodeBlock, r.makeHead1 && new DropdownSubmenu(cut([
    //     r.makeHead1, r.makeHead2, r.makeHead3, r.makeHead4, r.makeHead5, r.makeHead6
    // ]), {label: "Heading"})]), {label: "Type..."})

    r.typeMenu = new Dropdown(cut([r.makeHead1, r.makeHead2, r.makeHead3, r.makeHead4]), {label: "Heading"});

    // r.inlineMenu = [cut([r.toggleStrong, r.toggleEm, r.toggleCode, r.toggleLink])]
    r.inlineMenu = [cut([r.toggleStrong, r.toggleEm, r.toggleLink])]

    // r.blockMenu = [cut([r.wrapBulletList, r.wrapOrderedList, r.wrapBlockQuote, joinUpItem, liftItem, selectParentNodeItem])]
    r.blockMenu = [cut([r.wrapBulletList, r.wrapOrderedList, joinUpItem, liftItem, selectParentNodeItem])]

    r.fullMenu = r.inlineMenu.concat([[r.insertImage, r.insertVideo, r.typeMenu]], [[undoItem, redoItem]], r.blockMenu)

    return r
}